export const getNameInitials = (
  firstName: string,
  lastName: string
): string => {
  const firstNameInitial = firstName?.charAt(0).toLocaleUpperCase() || "";
  const lastNameInitial = lastName?.charAt(0).toLocaleUpperCase() || "";

  return firstNameInitial + lastNameInitial;
};
